module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "输卡号/查询码/代理商名"
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "开始日期"
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "结束日期"
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.searchDate()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportTable()
      }
    }
  }, [_vm._v("导出EXCEL")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "orderid",
      "label": "充值单据号",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "packtype",
      "label": "套餐类别",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "packname",
      "label": "套餐名称",
      "min-width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "msisdn",
      "label": "卡号",
      "min-width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "money",
      "label": "充值金额(元)",
      "min-width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ordertimestr",
      "label": "充值时间",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceusername",
      "label": "代理商名称",
      "min-width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "充值备注",
      "min-width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleClick(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "充值详细",
      "visible": _vm.userInfoFormVisible,
      "close-on-click-modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.userInfoFormVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto",
      "width": "100%"
    }
  }, [_c('table', {
    staticClass: "border-table"
  }, [_c('tr', [_c('td', {
    staticClass: "spec alt"
  }, [_vm._v("充值单据号:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.orderid))]), _vm._v(" "), _c('td', {
    staticClass: "alt spec"
  }, [_vm._v("套餐类别:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.packtype))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "spec alt"
  }, [_vm._v("套餐名称:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.packname))]), _vm._v(" "), _c('td', {
    staticClass: "alt spec"
  }, [_vm._v("卡号:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.msisdn))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "alt alt"
  }, [_vm._v("查询代码:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.querycode))]), _vm._v(" "), _c('td', {
    staticClass: "spec alt"
  }, [_vm._v("ICCID:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.iccid))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "alt spec"
  }, [_vm._v("支付金额:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.money) + "元")]), _vm._v(" "), _c('td', {
    staticClass: "alt spec"
  }, [_vm._v("套餐费用:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.rechargePrice) + "元")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "spec alt"
  }, [_vm._v("实际欠费:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.arreasPrice) + "元")]), _vm._v(" "), _c('td', {
    staticClass: "spec alt"
  }, [_vm._v("欠费补缴:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.arreas) + "元")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "spec alt"
  }, [_vm._v("充值来源:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.rechargeSource))]), _vm._v(" "), _c('td', {
    staticClass: "spec alt"
  }, [_vm._v("充值前到期时间:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.expireTime))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "spec alt"
  }, [_vm._v("充值后到期时间:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.rechargeExpireTime))]), _vm._v(" "), _c('td', {
    staticClass: "spec alt"
  }, [_vm._v("充值备注:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.remark))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "spec alt"
  }, [_vm._v("代理商名称:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.serviceusername))]), _vm._v(" "), _c('td', {
    staticClass: "alt spec"
  }, [_vm._v("订单时间:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.ordertimestr))])]), _vm._v(" "), (_vm.orderInfo.packtype == '叠加卡') ? _c('tr', [_c('td', {
    staticClass: "spec alt"
  }, [_vm._v("流量包大小:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.addgprssize) + "M")]), _vm._v(" "), _c('td', {
    staticClass: "alt spec"
  }, [_vm._v("流量包价格:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.addgprsprice) + "元")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.packtype == '叠加卡') ? _c('tr', [_c('td', {
    staticClass: "spec alt"
  }, [_vm._v("购买数量:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.orderInfo.addgprscount))])]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-6fb510d8!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/nav2/money_query.vue
// module id = 759
// module chunks = 2